<h3>Rejection Information</h3>
<br />
<div class="row col-12">
  <div class="col-6">
    <div class="label">Reason</div>
    <div class="details">
      {{rejectionDetails?.RejectedReasons?.join(', ')}}
    </div>
  </div>
  <div class="col-6">
    <div class="label">Comments</div>
    <div class="details">
      <span class="pre">{{rejectionDetails?.RejectionComment}}</span>
    </div>
  </div>
</div>

<div class="row col-12">
  <table class="tsl-table document-list" *ngIf="rejectionDetails?.RejectionAttachment">
    <thead>
      <tr class="tsl-header-row">
        <th class="label">Document Name</th>
        <th class="label">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr class="tsl-row" *ngFor="let item of [rejectionDetails.RejectionAttachment]; let i = index;">
        <td class="tsl-cell"> {{item.FileName}} </td>
        <td class="tsl-cell"><a class="link" (click)="DownloadFile(item)">Download</a></td>
      </tr>
    </tbody>
  </table>
</div>
<br />
